__turbopack_context__.v({
  "associated-products": "pDA1aW_associated-products",
  "box": "pDA1aW_box",
  "interactive": "pDA1aW_interactive",
  "is-current": "pDA1aW_is-current",
  "item": "pDA1aW_item",
  "list": "pDA1aW_list",
  "more-button": "pDA1aW_more-button",
  "oos-label": "pDA1aW_oos-label",
  "oos-layer": "pDA1aW_oos-layer",
  "out-of-stock": "pDA1aW_out-of-stock",
  "size-pdp": "pDA1aW_size-pdp",
  "thumb": "pDA1aW_thumb",
  "thumb-box": "pDA1aW_thumb-box",
  "thumb-text": "pDA1aW_thumb-text",
  "title": "pDA1aW_title",
});
